import { useMutation } from "@apollo/client";
import {
  MOVE_COMPANY_DOCUMENT,
  MOVE_COMPANY_DOCUMENT_FOLDER,
} from "../api/move-company-document-node";
import { GET_COMPANY_DOCUMENT_TREE } from "@/modules/documents/widgets/company-document-tree/api/get-company-document-tree";
import { GET_COMPANY_DOCUMENT_FOLDER_TREE } from "@/modules/documents/entities/company-document-folder-select/api/get-company-document-folder-tree";

export function useMoveCompanyDocumentNode() {
  const refetchQueries = [
    GET_COMPANY_DOCUMENT_TREE,
    GET_COMPANY_DOCUMENT_FOLDER_TREE,
  ];

  const [moveFolder, { loading: folderLoading }] = useMutation(
    MOVE_COMPANY_DOCUMENT_FOLDER,
    // Пока дерево не перечитано, следующий бросок проверялся бы по старым данным.
    { refetchQueries, awaitRefetchQueries: true },
  );
  const [moveDocument, { loading: documentLoading }] = useMutation(
    MOVE_COMPANY_DOCUMENT,
    // Пока дерево не перечитано, следующий бросок проверялся бы по старым данным.
    { refetchQueries, awaitRefetchQueries: true },
  );

  const moveFolderTo = async (folderId: string, newParentId?: string | null) =>
    moveFolder({ variables: { folderId, newParentId: newParentId ?? null } });

  const moveDocumentTo = async (documentId: string, folderId?: string | null) =>
    moveDocument({ variables: { documentId, folderId: folderId ?? null } });

  return {
    moveFolderTo,
    moveDocumentTo,
    loading: folderLoading || documentLoading,
  };
}
